// extracted by mini-css-extract-plugin
export default {"info-container":"ShoppingCartItemsNotFound_info-container__GMU3o"};